module.exports = __webpack_public_path__ + "static/debigniter-9b3b5e3be9af0d3fda03c90213b43164.svg";